<!-- Current Outages List Table -->
<div class="card table-container">
    <div class="row">
        <div class="col-12">
            <div class="card date_time_picker" id="reportranged">
                <div class="card-body" id="custom_body">
                    <em class="fa fa-calendar"></em>&nbsp;
                    <span></span>
                    <em class="fa fa-caret-down"></em>
                </div>
            </div>
        </div>
    </div>
    <div class="card-body" id="c_planned_outages_card_body">
        <table id="c_planned_outages_table">
            <thead>
                <tr id="c_planned_outages_header" class="cust-table-header">
                    <th style="flex: 0 0 100px;" id="po_itemName">
                        {{ 'OutagesList.itemNames' | translate }}
                    </th>
                    <th (click)="sort('startDate')" style="flex: 0 0 100px;" id="startDate">
                        <em class="fa fa-sort"
                            [ngClass]="{'fas fa-sort-down': (column == 'startDate' && isDesc), 'fas fa-sort-up': (column == 'startDate' && !isDesc) }"
                            aria-hidden="true">
                        </em>
                        {{ 'OutagesList.startDate' | translate }}
                    </th>
                    <th (click)="sort('endDate')" style="flex: 0 0 100px;" id="endDate">
                        <em class="fa fa-sort"
                            [ngClass]="{'fas fa-sort-down': (column == 'endDate' && isDesc), 'fas fa-sort-up': (column == 'endDate' && !isDesc) }"
                            aria-hidden="true">
                        </em>
                        {{ 'OutagesList.endDate' | translate }}
                    </th>
                    <th style="flex: 0 0 100px;" id="reason">
                        {{ 'OutagesList.reason' | translate }}
                    </th>

                </tr>
            </thead>
            <tbody *ngIf="isPlannedOutageslist" appInfinteScroll (scrolledEnd)="scrollEnd()" (scrolledCur)="scrollCur()">
                <tr id="c_planned_outages_table_body"
                    *ngFor="let outages of plannedOutagesBasicInfoResponse; let i=index;trackBy: trackByPlannedOutages"
                    routerLink='{{  outages.plannedOutageId }}' class="clickable table-body">
                    <td>
                        <div *ngFor="let itemnames of outages.itemNames">{{ itemnames }}</div>
                    </td>
                    <td>{{ outages.startDate }}</td>
                    <td>{{ outages.endDate }}</td>
                    <td>{{ showOutageReason(outages.reason)}}</td>
                </tr>
            </tbody>
            <tbody *ngIf="!isPlannedOutageslist  && !isLoading && !spinnerStart">
                    <tr class="norecords"> 
                        <td colspan="5" class="text-center">{{ 'CommonStrings.noRecords' | translate }}</td>
                    </tr>
                </tbody>
        </table>
    </div>
    <!-- Spinner -->
    <div class="text-center col-12" id="sd_store_item_loading ">
        <div *ngIf="isLoading || spinnerStart" id="spinner" role="progressbar">
            <zsd-spinner></zsd-spinner>
        </div>
    </div>
</div>
<!-- End of On Scroll Load Div -->
<div *ngIf="(scrollEndReached && plannedOutagesBasicInfoResponse?.length > 20) " class="text-center">
    <div class="card">
        <div class="card-body" id="c_no_request_message">
            {{ 'CommonStrings.endOfScroll' | translate }}
        </div>
    </div>
</div>